import React, { Component } from "react";
import ContentLoader from "react-content-loader";
import "./shimmer.scss";

function FeaturedContentLoader() {
  return (
    <div className="col-md-4 col-sm-6 col-xs-12 pb-40 pb-0-sm shimmer">
      <img src="" alt="" aria-hidden="true" className="placeholder placeholder-featured" />
      <ContentLoader height={300} speed={2} className="shimmer-element">
        <rect x="5" y="5" rx="3" ry="3" width="390" height="200" />
        <rect x="15" y="220" rx="3" ry="3" width="370" height="25" />
        <rect x="15" y="255" rx="3" ry="3" width="370" height="8" />
        <rect x="15" y="269" rx="3" ry="3" width="370" height="8" />
        <rect x="15" y="283" rx="3" ry="3" width="370" height="8" />
      </ContentLoader>
    </div>
  );
}

class FeaturedContentShimmer extends Component {
  render() {
    return (
      <>
        <FeaturedContentLoader />
        <FeaturedContentLoader />
        <FeaturedContentLoader />
      </>
    );
  }
}

export default FeaturedContentShimmer;
